import { useState, useEffect } from 'react'
import { useSelector } from 'react-redux'

import { Galaktika_BG } from '../../assets/img'
import { getShopItems } from '../../features/shopItems/shopItemsSlice'
import { handlePaginationGeneral } from '../../utilities/Pagination'
import { Container } from '../containers/Container'
import SecondaryLayout from '../layout/secondaryLayout'
import ShopItem from './ShopItem'

const ViewShop = () => {
  const balance = useSelector((state) => state.balance.Balance)
  const shopItems = useSelector((state) => state.shopItems.info)
  // const collection = useSelector((state) => state.galaktikaCollection)

  const [pagination, setPagination] = useState(0)
  const [itemsPerPage, setItemsPerPage] = useState(4)

  const handlePagination = (action) => {
    handlePaginationGeneral(
      action,
      pagination,
      itemsPerPage,
      shopItems,
      setPagination,
      true,
    )
  }

  useEffect(() => {
    getShopItems()
  }, [shopItems])

  return (
    <SecondaryLayout
      background={Galaktika_BG}
      pageTitle="Shop"
      secondaryTitle={
        <p className="text-cyanBlue font-ethnocentric pl2 text-display--lg whitespace-nowrap font-normal text-right">
          {' '}
          {balance.GLK.toFixed(2).toLocaleString()} GLK | 0 GLC
        </p>
      }
    >
      <Container vertical={false} type={'collection'}>
        <div className="flex flex-wrap flex-col gap-12 justify-center items-center">
          <div className='flex gap-12'>
            {
              // Object.entries(SHOP_PRODUCTS).map(([title, { img, stock, price, drop_id }], _)
              shopItems
                ?.slice(pagination, pagination + itemsPerPage)
                .map(({ data, details }, _) => (
                  <ShopItem
                    key={`${data.schema_name}_${data.template_id}_${_}`}
                    id={data.template_id}
                    title={details.name}
                    img={details?.img}
                    video={details?.video}
                    available={
                      data.is_available
                        ? data.total_quantity - data.total_sold
                        : 'No'
                    }
                    price={data.required_tokens[0].asset_group[0]}
                  />
                ))
            }
          </div>
          <div id="overlay-controls" className="flex justify-center items-center">
            <div
              className="text-4xl text-white cursor-pointer"
              onClick={() => handlePagination(-1)}
            >
              {'<'}
            </div>
            <div className='text-white text-4xl' id="count-display"> {`${
                Math.ceil(pagination/ itemsPerPage) + 1
              }/${Math.ceil(shopItems.length / itemsPerPage)} `} </div>
            <div
              className="text-4xl text-white cursor-pointer"
              onClick={() => handlePagination(1)}
            >
              {'>'}
            </div>
          </div>
        </div>
      </Container>
    </SecondaryLayout>
  )
}

export default ViewShop
